import { z } from 'zod';

import { GRANT_ROLES, MAX_USER_GRANTS } from '../constants/users.js';
import { t } from '../i18n/validation.js';

const USERNAME_REGEX = /^[a-zA-Z0-9._-]+$/;

const grantSchema = z.object({
  tagId: z.string(),
  tagName: z.string(),
  role: z.enum(GRANT_ROLES),
});

export const userFormSchemaBase = z.object({
  username: z
    .string()
    .trim()
    .min(3, t('validation.user.usernameMinLength'))
    .regex(USERNAME_REGEX, t('validation.user.usernameFormat')),
  password: z.string(),
  isAdmin: z.boolean(),
  grants: z
    .array(grantSchema)
    .max(MAX_USER_GRANTS, t('validation.maxTags', { max: MAX_USER_GRANTS }))
    .refine((grants) => new Set(grants.map((grant) => grant.tagId)).size === grants.length, {
      message: t('validation.user.duplicateGrantTag'),
    }),
});

export type UserFormValues = z.infer<typeof userFormSchemaBase>;

export const createUserFormSchema = (mode: 'create' | 'edit') =>
  userFormSchemaBase.superRefine((data, ctx) => {
    if (mode === 'create') {
      if (data.password.length < 6) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['password'],
          message: t('validation.user.passwordMinLength'),
        });
      }
    } else if (data.password.length > 0 && data.password.length < 6) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['password'],
        message: t('validation.user.passwordMinLength'),
      });
    }
  });
